import { z } from 'zod';
import { payableDataSchema } from '../../Payable.js';
import { RegistrationServiceConfigSchema } from '../configurations/RegistrationServiceConfig.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderRegistrationDataSchema = servicesProviderGenericDataSchema
    .merge(payableDataSchema)
    .extend({
    config: z.object({
        [Services.REGISTRATION]: RegistrationServiceConfigSchema,
    }),
});

export { servicesProviderRegistrationDataSchema };
//# sourceMappingURL=ServicesProviderRegistrationData.js.map
